import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DataTable from '../DataTable/DataTable';
import DataTablePagination from '../DataTable/DataTablePagination/DataTablePagination';
import { DEFAULT_DIRECTION, DIRECTION } from '../../../../constants/constants';

const defaultPageSize = 20;

class PagingAndSortingDataTable extends PureComponent {
  constructor(props) {
    super(props);

    const totalElements = props.bodyData.length;

    this.state = {
      page: {
        size: defaultPageSize,
        numberOfElements:
          totalElements < defaultPageSize ? totalElements : defaultPageSize,
        totalElements,
        number: 0
      },
      sortBy: {
        name: props.defaultSortByKey || props.columns[0].sortBy,
        direction: 'asc'
      }
    };

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleRequestSort = this.handleRequestSort.bind(this);
    this.updateNumberOfElements = this.updateNumberOfElements.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.getTransformedData = this.getTransformedData.bind(this);
    this.getColumns = this.getColumns.bind(this);
  }

  updateNumberOfElements() {
    const remainingElements =
      this.state.page.totalElements -
      this.state.page.size * this.state.page.number;
    this.setState({
      page: {
        ...this.state.page,
        numberOfElements:
          remainingElements < this.state.page.size
            ? remainingElements
            : this.state.page.size
      }
    });
  }

  handleChangePage(number) {
    this.setState(
      {
        page: {
          ...this.state.page,
          number
        }
      },
      this.updateNumberOfElements
    );
  }

  handleRequestSort(name) {
    const direction =
      this.state.sortBy.name === name
        ? DIRECTION[this.state.sortBy.direction].opposite
        : DEFAULT_DIRECTION;

    this.setState({
      sortBy: {
        name,
        direction
      }
    });
  }

  handleChangeRowsPerPage(size) {
    this.setState(
      {
        page: {
          ...this.state.page,
          size,
          number: 0
        }
      },
      this.updateNumberOfElements
    );
  }

  getTransformedData() {
    const sortedData = this.props.sort(this.props.bodyData, this.state.sortBy);
    const start = this.state.page.size * this.state.page.number;
    const end = start + this.state.page.numberOfElements;
    return sortedData.slice(start, end);
  }

  getColumns() {
    return this.props.columns.map((column) => ({
      ...column,
      header: {
        ...column.header,
        onRequestSort: () => this.handleRequestSort(column.header.sortBy),
        isSortedBy: () => column.header.sortBy === this.state.sortBy.name
      }
    }));
  }

  render() {
    return (
      <DataTable
        columns={this.getColumns()}
        bodyData={this.getTransformedData()}
        direction={this.state.sortBy.direction}
        footerContent={
          <DataTablePagination
            page={this.state.page}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        }
      />
    );
  }
}

PagingAndSortingDataTable.propTypes = {
  columns: PropTypes.array.isRequired,
  bodyData: PropTypes.array.isRequired,
  sort: PropTypes.func.isRequired,
  defaultSortByKey: PropTypes.string
};

export default PagingAndSortingDataTable;
